<template>
  <div>
    <div id="colnav">
        <div id="leftpannel">
            <h2>Luc Libralesso</h2>
            <h2 class="nobold smallfont">Optimization<br/>Meta-heuristics</h2>
            <img id="profileimg" :src="profile" />
            <div class="sep"></div>
            <div id="leftmenu" v-for="tab in tabinfo" :key="tab.path">
                <a :href="tab.path" class="leftmenuitem" :class="{active: tab.path===currentpath}">
                    <i class="icon material-icons">{{tab.icon}}</i>
                    <span class="text">{{tab.title}}</span>
                </a>
            </div>
        </div>
        <div id="rightpannel">
            <div><i id="menuicon" class="material-icons" @click="togglemenu">arrow_back</i></div>
            <div id="content">
                <slot></slot>
            </div>
      </div>
    </div>
  </div>
</template>
<script>

const tabinfo = [
    {
        path: '/',
        icon: 'home',
        title: 'Home',
    }, {
        path: '/research',
        icon: 'import_contacts',
        title: 'Research',
    }, {
        path: '/teaching',
        icon: 'school',
        title: 'Teachings',
    }, {
        path: '/awards',
        icon: 'grade',
        title: 'Awards',
    }, {
        path: '/projects',
        icon: 'computer',
        title: 'Projects',
    }
];

export default {
  name: "Nav",
  props: ["currentpath"],
  data() {
      return {
          profile: require('../../public/profile.jpg'),
          tabinfo: tabinfo,
          menuopen: true,
      }
  },
  methods: {
        togglemenu: function() {
            let elt_left = document.querySelector("#leftpannel")  // menu dom element
            let elt_right = document.querySelector("#rightpannel")  // menu dom element
            let menu_button = document.querySelector("#menuicon")
            if ( this.menuopen ) {
                elt_left.style.left = "-250px"
                elt_right.style["margin-left"] = "0px"
                menu_button.style.transform = "rotate(180deg)"
            } else {
                elt_left.style.left = "0px"
                elt_right.style["margin-left"] = "251px"
                menu_button.style.transform = "rotate(0deg)"
            }
            this.menuopen = !this.menuopen
        },
  },
  components: {}
};
</script>
<style lang="scss">
@import '~material-design-icons/iconfont/material-icons.css';
@import "../styles/common.scss";

$leftpannelsize: 250px;

.smallfont {
    font-size: 1.35em;
}

#colnav {
    display: flex;
    flex-direction: row;

    #leftpannel {
        background-color: $menuback;
        min-height: 100%;
        width: $leftpannelsize;
        position: fixed;
        top: 0;
        left: 0;
        border-right: 1px solid #111;
        transition: left 0.15s;
        color: $menufont;
        text-align: center;

        h2, h3 {
            margin: 7px;
            margin-top: 20px;
            margin-bottom: 30px;
            margin-left: 30px;
            text-align: left;
        }
        
        #profileimg {
            width: 150px;
            height: 150px;
            border-radius: 200px;
            border: 2px solid white;
            background-color: $menufont;
            // box-shadow: 7px 7px 7px #222;
        }

        .sep {
            height: 30px;
            border-bottom: 1px solid #222;
        }

        #leftmenu {

            .leftmenuitem {
                text-decoration: none;
                padding: 20px;
                border-bottom: 1px solid #222;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .text {
                    font-size: 1.2em;
                    color: $menufont;
                    font-weight: normal;
                }

                .icon {
                    color: $menufont;
                    font-size: 2em;
                }
            }
            .leftmenuitem:hover {
                background-color: $menubacklight;
            }

            .leftmenuitem.active {
                background-color: #222;
                border-bottom: 1px solid #111;
                .text {
                    color: $menufontselect;
                }
                .icon {
                    color: $menufontselect;
                }
            }
        }
    }

    #rightpannel {

        margin-left: $leftpannelsize+1;
        width: 100%;
        background-color: $contentback;
        transition: margin-left 0.15s;

        #menuicon {
            font-size: 2em;
            padding: 7px;
            margin: 7px 0 0 10px;
            float: left;
            cursor: pointer;
            user-select: none;
            border-radius: 25px;
            transition: transform .7s;
        }

        #menuicon:hover {
            background-color: #f5f5f5;
            color: $menufontselect;
        }

        #content {
            padding: 10px;
            margin: auto;
            max-width: 750px;
        }
    }
}
</style>